import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
// import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
// import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import { MatDialogModule } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
// import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
// import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
// import { MatPaginatorModule as MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
// import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
// import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
// import { MatTableModule } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
// import { MatTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
// import { MatTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { OverlayLoaderComponent } from './components/overlay-loader/overlay-loader.component';
import { DragDirective } from './directives/drag.directive';
import { C3TimeSeriesComponent } from './components/c3-time-series/c3-time-series.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { HistogramComponent } from './components/histogram/histogram.component';
import { DonutChartComponent } from 'src/app/shared/components/donut-chart/donut-chart.component';
import { CalendarModule } from 'primeng/calendar';
import { CustomDateSelectorComponent } from './components/custom-date-selector/custom-date-selector.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UnauthorizedComponent } from 'src/app/shared/components/unauthorized/unauthorized.component';
import { C3BatchSeriesComponent } from './components/c3-batch-series/c3-batch-series.component';
import { C3TrendSeriesComponent } from './components/c3-trend-series/c3-trend-series.component';
import { ErrorComponent } from './components/error/error.component';
import { TranslateModule } from '@ngx-translate/core';
import { C3EgaBarComponent } from './components/c3-ega-bar/c3-ega-bar.component';
import { C3DrillDownBarComponent } from './components/c3-drill-down-bar/c3-drill-down-bar.component';
import { C3BarchartDashboardComponent } from './components/c3-barchart-dashboard/c3-barchart-dashboard.component';
import { EgaCustomDateSelectorComponent } from './components/ega-custom-date-selector/ega-custom-date-selector.component';
import { C3EgaTimeSeriesComponent } from './components/c3-ega-time-series/c3-ega-time-series.component';
import { OutlierFilterPipe } from 'src/app/shared/pipe/outlier-filter';
import { NoRoleComponent } from './components/no-role/no-role.component';
import { ChartYzoomComponent } from './components/chart-yzoom/chart-yzoom.component';
import { C3ScatterPlotComponent } from './components/c3-scatter-plot/c3-scatter-plot.component';
import { D3HeatmapComponent } from './components/d3-heatmap/d3-heatmap.component';
// import { MatSelectFilterModule } from 'mat-select-filter';
import { MatSelectSearchModule } from 'mat-select-search';
import { D3ZoneChartComponent } from './components/d3-zone-chart/d3-zone-chart.component';
import { EgaShiftDateSelectorComponent } from './components/ega-shift-date-selector/ega-shift-date-selector.component';
import { NgxMatDatetimepicker, NgxMatDatepickerInput, NgxMatDatepickerActions, NgxMatDatepickerApply, NgxMatDatepickerCancel, NgxMatDatepickerClear } from '@ngxmc/datetime-picker'
import { C3ThresholdDiagramComponent } from './components/c3-threshold-diagram/c3-threshold-diagram.component';
import { TreeChartComponent } from './components/tree-chart/tree-chart.component';
import { C3SummaryChartComponent } from './components/c3-summary-chart/c3-summary-chart.component';
import { SummaryTableComponent } from './components/summary-table/summary-table.component';
import { ChartPaginatorComponent } from './components/chart-paginator/chart-paginator.component';
import { RemoveAriaOwnsDirective } from './directives/remove-aria-owns.directive';
import { RoleDirective } from './directives/role.directive';
import { RoleInputDirective } from './directives/roleInput.directive';
import { KeyRoleDirective } from './directives/key-role.directive';
import { CiCustomDateSelectorComponent } from './components/ci-custom-date-selector/ci-custom-date-selector.component';
import { D3CiSunburnComponent } from './components/d3-ci-sunburn/d3-ci-sunburn.component';
import { RoleAddEditDirective } from './directives/role-add-edit.directive';
import { C3CiTimeSeriesComponent } from './c3-ci-time-series/c3-ci-time-series.component';
import { D3CitreeComponent } from './components/d3-citree/d3-citree.component';


@NgModule({
        declarations: [
                ConfirmDialogComponent,
                OverlayLoaderComponent,
                DragDirective,
                C3TimeSeriesComponent,
                HistogramComponent,
                DonutChartComponent,
                CustomDateSelectorComponent,
                UnauthorizedComponent,
                C3BatchSeriesComponent,
                C3TrendSeriesComponent,
                ErrorComponent,
                C3EgaBarComponent,
                C3DrillDownBarComponent,
                C3BarchartDashboardComponent,
                EgaCustomDateSelectorComponent,
                C3EgaTimeSeriesComponent,
                OutlierFilterPipe,
                NoRoleComponent,
                ChartYzoomComponent,
                C3ScatterPlotComponent,
                C3ThresholdDiagramComponent,
                D3HeatmapComponent,
                D3ZoneChartComponent,
                EgaShiftDateSelectorComponent,
                TreeChartComponent,
                C3SummaryChartComponent,
                SummaryTableComponent,
                ChartPaginatorComponent,
                RemoveAriaOwnsDirective,
                RoleDirective,
                RoleInputDirective,
                KeyRoleDirective,
                CiCustomDateSelectorComponent,
                D3CiSunburnComponent,
                RoleAddEditDirective,
                C3CiTimeSeriesComponent,
                D3CitreeComponent
        ],
        imports: [
                CommonModule,
                ReactiveFormsModule,
                MatIconModule,
                FlexLayoutModule,
                MatButtonModule,
                MatSelectModule,
                MatPaginatorModule,
                MatSortModule,
                MatTableModule,
                MatRippleModule,
                MatDialogModule,
                MatFormFieldModule,
                MatInputModule,
                MatBadgeModule,
                MatProgressSpinnerModule,
                MatRadioModule,
                MatSlideToggleModule,
                MatCheckboxModule,
                MatAutocompleteModule,
                PopoverModule,
                CalendarModule,
                MatButtonToggleModule,
                MatTooltipModule,
                FormsModule,
                MatTabsModule,
                NgxPermissionsModule,
                MatSidenavModule,
                MatToolbarModule,
                TranslateModule.forChild(),
                // MatSelectFilterModule,
                MatSelectSearchModule,
                MatDatepickerModule, MatNativeDateModule,
                // NgxMatDatetimePickerModule, NgxMatTimepickerModule
                NgxMatDatetimepicker, NgxMatDatepickerInput, NgxMatDatepickerActions, NgxMatDatepickerApply, NgxMatDatepickerCancel, NgxMatDatepickerClear
        ], exports: [
                ReactiveFormsModule,
                FlexLayoutModule,
                MatIconModule,
                MatButtonModule,
                MatSelectModule,
                MatPaginatorModule,
                MatSortModule,
                MatTableModule,
                MatRippleModule,
                MatDialogModule,
                MatFormFieldModule,
                MatInputModule,
                MatBadgeModule,
                OverlayLoaderComponent,
                MatRadioModule,
                DragDirective,
                C3TimeSeriesComponent,
                C3BatchSeriesComponent,
                C3TrendSeriesComponent,
                CustomDateSelectorComponent,
                MatSlideToggleModule,
                MatCheckboxModule,
                MatAutocompleteModule,
                PopoverModule,
                HistogramComponent,
                CalendarModule,
                MatButtonToggleModule,
                DonutChartComponent,
                MatTooltipModule,
                NgxPermissionsModule,
                UnauthorizedComponent,
                MatTabsModule,
                MatSidenavModule,
                MatToolbarModule,
                TranslateModule,
                C3EgaBarComponent,
                C3DrillDownBarComponent,
                C3BarchartDashboardComponent,
                EgaCustomDateSelectorComponent,
                EgaShiftDateSelectorComponent,
                C3EgaTimeSeriesComponent,
                OutlierFilterPipe,
                ChartYzoomComponent,
                C3ScatterPlotComponent,
                D3HeatmapComponent,
                // MatSelectFilterModule,
                MatSelectSearchModule,
                D3ZoneChartComponent,
                MatDatepickerModule, MatNativeDateModule,
                // NgxMatDatetimePickerModule,
                // NgxMatNativeDateModule,
                // NgxMatTimepickerModule,
                NgxMatDatetimepicker, NgxMatDatepickerInput, NgxMatDatepickerActions, NgxMatDatepickerApply, NgxMatDatepickerCancel, NgxMatDatepickerClear,
                C3ThresholdDiagramComponent,
                TreeChartComponent,
                C3SummaryChartComponent,
                SummaryTableComponent,
                ChartPaginatorComponent,
                RemoveAriaOwnsDirective,
                RoleDirective,
                RoleInputDirective,
                KeyRoleDirective,
                CiCustomDateSelectorComponent,
                D3CiSunburnComponent,
                RoleAddEditDirective,
                C3CiTimeSeriesComponent,
                D3CitreeComponent
        ]
})
export class SharedModule { }
